export const SAITAMA_INSPECTION_ITEMS = Object.freeze([
  Object.freeze({ code: "NO_ABNORMALITY", label: "異常なし" }),
  Object.freeze({ code: "BODY_TILT", label: "本体の傾き" }),
  Object.freeze({ code: "BODY_RUST_CORROSION", label: "本体の錆び・腐食" }),
  Object.freeze({ code: "BODY_ATTACHMENT", label: "本体への付着（貼り紙・落書き・ツル草など）" }),
  Object.freeze({ code: "LAMP_DAMAGE", label: "灯具の割れ・破損" }),
]);

export const SAITAMA_INSPECTION_CODES = SAITAMA_INSPECTION_ITEMS.map(({ code }) => code);

export const SAITAMA_INSPECTION_FILTER_ITEMS = Object.freeze([
  Object.freeze({ code: "UNINSPECTED", label: "未点検" }),
  ...SAITAMA_INSPECTION_ITEMS,
]);

export const SAITAMA_INSPECTION_LABELS = Object.freeze(
  SAITAMA_INSPECTION_ITEMS.reduce((labels, item) => {
    labels[item.code] = item.label;
    return labels;
  }, {})
);
